import { capitalCase } from 'change-case';

import { dayjs } from '@/utilities';

import type { FinancialOverviewCorporateDebtNote } from '../../types';

export const formatDebtRateType = (rateType: string) => {
    const label = capitalCase(rateType);

    return /\brate$/i.test(label) ? label : `${label} Rate`;
};

export const getDebtNoteMetadata = (note: FinancialOverviewCorporateDebtNote) =>
    [
        note.seniority,
        note.rateType ? formatDebtRateType(note.rateType) : undefined,
        note.secured === true ? 'Secured' : note.secured === false ? 'Unsecured' : undefined,
        note.convertible ? 'Convertible' : undefined,
        note.currency,
        note.issuedYear ? `Issued ${note.issuedYear}` : undefined,
        note.filingType
            ? `${note.filingType}${note.filingDate && dayjs(note.filingDate).isValid() ? ` filed ${dayjs(note.filingDate).format('MMM D, YYYY')}` : ''}`
            : undefined,
    ].filter((value): value is string => Boolean(value));

const maturitySortValue = (note: FinancialOverviewCorporateDebtNote) => {
    if (note.maturityDate && dayjs(note.maturityDate).isValid()) {
        return dayjs(note.maturityDate).valueOf();
    }

    return note.maturityYear ? dayjs(`${note.maturityYear}-12-31`).valueOf() : 0;
};

export const orderDebtNotesByMaturity = (notes: FinancialOverviewCorporateDebtNote[]) =>
    [...notes].sort((left, right) => maturitySortValue(right) - maturitySortValue(left));
